
import { CheckIcon } from 'vue-feather-icons';
import { Button } from 'element-ui';
import LoyaltyOurStatusItems from './LoyaltyOurStatusItems.vue';
export default {
  components: {
    CheckIcon,
    Button,
    LoyaltyOurStatusItems,
  },

  computed: {
    loyaltyLink() {
      let link = this.localePath({ name: `account-loyalty-membership` });
      if (!this.$auth.loggedIn) {
        return this.localePath({
          name: 'authenticate-route',
          params: {
            route: 'login',
          },
          query: {
            redirect: 'account-loyalty-membership',
          },
        });
      }
      return link;
    },
  },
};
